import { useState } from 'react';
import Raven from 'raven-js';
import { useSendCrmMessageTopic } from 'crm-message-bus/useSendCrmMessageTopic';
import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
import { MARKETING_EVENT_TYPE_ID, CAMPAIGN_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import CampaignsPlatformEditModalLegacy from '../CampaignsPlatformEditModalLegacy';
import { associateWithMarketingEvent } from './api/campaignsLegacyAssociationApi';
import { jsx as _jsx } from "react/jsx-runtime";
function MarketingEventCampaignAddPannel(props) {
  const {
    marketingEventId,
    onClose
  } = props;
  const [selectedCampaign, setSelectedCampaign] = useState();
  const sendUpdateAssociation = useSendCrmMessageTopic(TOPIC_NAMES.UPDATE_ASSOCIATIONS);
  function handleAddCampaign(selectedOption) {
    var _selectedOption$value, _selectedOption$value2;
    setSelectedCampaign(selectedOption.value);
    if (!(selectedOption !== null && selectedOption !== void 0 && selectedOption.value)) {
      return;
    }
    const campaignGuid = Array.isArray(selectedOption.value) ? ((_selectedOption$value = selectedOption.value[0]) === null || _selectedOption$value === void 0 ? void 0 : _selectedOption$value.toString()) || '' : ((_selectedOption$value2 = selectedOption.value) === null || _selectedOption$value2 === void 0 ? void 0 : _selectedOption$value2.toString()) || '';
    associateWithMarketingEvent(marketingEventId, campaignGuid).then(() => {
      sendUpdateAssociation({
        objectId: `${marketingEventId}`,
        objectTypeId: MARKETING_EVENT_TYPE_ID,
        toObjectTypeId: CAMPAIGN_TYPE_ID
      });
    }).catch(error => {
      Raven.captureException(error);
    });
  }
  return /*#__PURE__*/_jsx(CampaignsPlatformEditModalLegacy, {
    selectedCampaign: selectedCampaign,
    assetObjectType: MARKETING_EVENT_TYPE_ID,
    hasCampaignsWriteAccess: true,
    onClose: onClose,
    onEditCampaignConfirm: handleAddCampaign
  });
}
export default MarketingEventCampaignAddPannel;